import { mount } from "@vue/test-utils";
import Paso1 from "@/views/Paso1";

jest.mock("@/views/Paso1", () => ({
  __esModule: true,
  ...jest.requireActual("@/views/Paso1"),
  default: {}
}));

describe("Paso1 test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(Paso1);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component Paso1", () => {
    expect(wrapper).toBeDefined();
  });
});
